import {IndividualManufacture, NotIncluded, Resale, Service} from "./RoamingInvoiceWrapper";

export const InvoiceCreated = 0
export const InvoiceSend = 1
export const InvoiceDeleted = 2
export const InvoiceCanceled = 3
export const CustomerApproved = 4
export const CustomerDeclined = 5

export const GetStatusTextReturnInvoice = status => {
    switch (status) {
        case InvoiceCreated:
            return "edi.return_invoice.status.invoice_created"
        case InvoiceSend:
            return "edi.return_invoice.status.invoice_send"
        case InvoiceDeleted:
            return "edi.return_invoice.status.invoice_deleted"
        case InvoiceCanceled:
            return "edi.return_invoice.status.invoice_canceled"
        case CustomerApproved:
            return "edi.return_invoice.status.customer_approved"
        case CustomerDeclined:
            return "edi.return_invoice.status.customer_declined"
        default:
            return "edi.return_invoice.status.default"
    }
}
export const getStatusColorReturnInvoice = status => {
    switch (status) {
        case InvoiceCreated:
            return '#263238'
        case InvoiceSend:
            return '#2196f3'
        case InvoiceDeleted:
            return '#ff9800'
        case InvoiceCanceled:
            return '#f44336'
        case CustomerApproved:
            return '#4caf50'
        case CustomerDeclined:
            return '#b71c1c'
        default:
            return '#263238'
    }
}

export const ReturnInvoiceStatuses = [
    {id: InvoiceCreated, name: GetStatusTextReturnInvoice(InvoiceCreated)},
    {id: InvoiceSend, name: GetStatusTextReturnInvoice(InvoiceSend)},
    {id: InvoiceDeleted, name: GetStatusTextReturnInvoice(InvoiceDeleted)},
    {id: InvoiceCanceled, name: GetStatusTextReturnInvoice(InvoiceCanceled)},
    {id: CustomerApproved, name: GetStatusTextReturnInvoice(CustomerApproved)},
    {id: CustomerDeclined, name: GetStatusTextReturnInvoice(CustomerDeclined)}
]

export const ReturnInvoiceNdsZeroNoneVatPayers = 1;

class ReturnInvoiceWrapper {
    getNdsInfo(ndsStatusInfo) {
        let ndsInfo = null;
        if(ndsStatusInfo && ndsStatusInfo.is_safe) {
            switch(true) {
                case ndsStatusInfo.is_suspended:
                    ndsInfo = ndsStatusInfo.registration_code;
                    break;
                case ndsStatusInfo.is_active:
                    ndsInfo = ndsStatusInfo.registration_code;
                    break;
                default:
                    break;
            }
        }
        return ndsInfo;
    }

    getItemOriginText(type) {
        switch (type) {
            case IndividualManufacture:
                return "roaming.invoice.items.origin_types.1";
            case Resale:
                return "roaming.invoice.items.origin_types.2";
            case Service:
                return "roaming.invoice.items.origin_types.3";
            case NotIncluded:
                return "roaming.invoice.items.origin_types.4";
            default:
                return;
        }
    }
}

const returnInvoiceWrapper = new ReturnInvoiceWrapper();
export default returnInvoiceWrapper;